module.exports = __webpack_public_path__ + "static/img/Patient_Appointment_Schedule.24ba132.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Patient_Appointment_Schedule.jpg
// module id = J+t2
// module chunks = 0